import { render, staticRenderFns } from "./geneHelp.vue?vue&type=template&id=fad262b6&"
import script from "./geneHelp.vue?vue&type=script&lang=js&"
export * from "./geneHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports